module.exports = __webpack_public_path__ + "static/media/empty_icon.43725e80.svg";